import React, { useEffect, useState } from 'react';
import { PageHeaderLeftIcon } from '@shared/infrastructure/ui/components/header/pageHeader';
import { historyRepository } from '@shared/domain/router/router.repository';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ROUTES } from '@shared/infrastructure/router/paths';
import { useAppSelector } from '@shared/infrastructure/state/store';
import {
  countryCodeSelector,
  languageCodeSelector
} from '@shared/infrastructure/state/global.slice';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Box, Button, IconButton } from '@mui/material';
import { routeRepository } from '@shared/domain/router/route/route.repository';
import { contentRepository } from '@shared/domain/content/content.repository';
import { Content } from '@shared/domain/content/content.aggregate';
import { ContentEditLayout } from './contentEdit/contentEditLayout';
import { ContentInfo } from './contentEdit/contentInfo';
import { ContentSettings } from './contentEdit/contentSettings';

export const ContentCreate = () => {
  const countryCode = useAppSelector(countryCodeSelector);
  const languageCode = useAppSelector(languageCodeSelector);
  const {} =
    routeRepository.getParams(
      ROUTES.CONTENTS_CREATE.path,
      window.location.pathname
    ) || {};

  const { control, handleSubmit, watch } = useForm<Content>({
    defaultValues: {
      name: '',
      nameLanguage: '',
      url: '',
      thumbnailUrl:
        'https://vclincprodst.blob.core.windows.net/documents/DefaultThumbnail.png'
    }
  });
  const back = () =>
    historyRepository.push(
      routeRepository.buildRoute(ROUTES.CONTENTS.path, {})
    );
  const onSubmit: SubmitHandler<Content> = (data) => {
    contentRepository
      .createContent(countryCode, languageCode, {
        ...data
      })
      .then(back, (error) => {
        throw error;
      });
  };

  const kind = watch('kind');

  return (
    <>
      <PageHeaderLeftIcon
        icon={
          <IconButton
            size='large'
            color='inherit'
            aria-label='back button'
            sx={{ mr: 2 }}
            onClick={back}
          >
            <ArrowBackIcon fontSize='large' />
          </IconButton>
        }
      >
        <Box sx={{ textAlign: 'center' }}>
          <p>Create content</p>
          <p>
            <small>
              Country: {countryCode}, Language: {languageCode}
            </small>
          </p>
        </Box>
      </PageHeaderLeftIcon>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ContentEditLayout
          left={<ContentInfo control={control} />}
          right={
            <ContentSettings
              control={control}
              disableKind={false}
              kind={kind}
            />
          }
          buttons={
            <Button
              sx={{
                marginTop: '1rem',
                padding: '1rem 1.5rem'
              }}
              type='submit'
              variant='contained'
              color='primary'
            >
              Create
            </Button>
          }
        />
      </form>
    </>
  );
};
